// extracted by mini-css-extract-plugin
export default {"quill_container":"textEditar_quill_container__DMuOC"};